// ImageKit's default URL has the account ID as its first path segment.
export const imagekitWidth = (source, width) => {
  if (!source) return source;
  try {
    const url = new URL(source);
    if (url.hostname !== "ik.imagekit.io") return source;
    const segments = url.pathname.split("/").filter(Boolean);
    if (segments.length < 2 || segments[1].startsWith("tr:")) return source;
    url.pathname = `/${segments[0]}/tr:w-${width}/${segments.slice(1).join("/")}`;
    return url.toString();
  } catch {
    return source;
  }
};
